"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var styles_1 = require("./styles");
var Step = function (_a) {
    var _b;
    var index = _a.index, totalSteps = _a.totalSteps, step = _a.step, testId = _a.testId, renderSubTitle = _a.renderSubTitle, onClick = _a.onClick, clickable = _a.clickable;
    var styles = (0, styles_1.useStateStyles)(step.state);
    var renderHelpText = function () {
        if (step.state === 'upcoming') {
            return null;
        }
        if (renderSubTitle) {
            return renderSubTitle(step.state, index);
        }
        return ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "label", strong: false, size: "base", color: styles.subTitle }, { children: "Step ".concat(index + 1, " of ").concat(totalSteps) })));
    };
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(step.name);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": testId, onClick: clickable ? handleClick : undefined, className: (0, classnames_1.default)('squid-flex', 'squid-items-center', 'squid-p-component-step-padding', 'squid-gap-component-step-space', 'squid-rounded-component-step-border-radius', 'squid-w-full', styles.container, (_b = {}, _b[styles.hover] = clickable, _b)) }, { children: [['current', 'upcoming'].includes(step.state) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)("squid-min-w-[16px] \n          squid-min-h-[16px] \n          squid-w-4 \n          squid-h-4 \n          squid-flex \n          squid-items-center \n          squid-justify-center \n          squid-border \n          squid-rounded-alias-border-radius-circle", styles.indicatorContainer) }, { children: step.state === 'current' && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('squid-w-1.5', 'squid-h-1.5', 'squid-border', 'squid-rounded-alias-border-radius-circle', styles.indicator) })) }))), ['completed', 'skipped'].includes(step.state) && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: step.state === 'completed' ? 'CheckCircle' : 'AlertCircle', size: "md", fill: step.state === 'completed' ? 'success' : 'attention' })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "squid-flex squid-flex-col" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "label", size: "base", color: styles.title, className: "squid-whitespace-nowrap" }, { children: step.title })), renderHelpText()] }))] }), step.name));
};
exports.Step = Step;
